import React, {Component} from "react";

class SimpleSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const {label, mandatory, type} = this.props
        return (
            <div className="margin-bottom-15px card-date-picker">
                <div className="margin-5px">
                    <div className="txt-site txt-11 txt-main txt-bold">
                        <h4>{label} {mandatory && <span style={{color: 'red'}}>*</span>}</h4>
                    </div>
                </div>
                <div className="double">
                    <input
                        {...this.props}
                        style={{backgroundColor: "#E6E6E6", padding: 15}}
                        className="input"
                        name="search"
                        disabled>
                    </input>
                    {type !== 'view' &&
                    <button
                        className="btn btn-grey border-left btn-no-radius"
                        type="button"
                        onClick={this.props.onSearch}>
                        <i className="fa fa-lg fa-search"></i>
                    </button>}
                </div>
            </div>
        )
    }
}

export default SimpleSearch